import {
  Box,
  Grid,
  createTheme,
  Menu,
  Stack,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogTitle,
  DialogActions,
  Select,
  FormLabel,
} from "@mui/material";

import React, { useEffect, useState, useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import AddIcon from "@mui/icons-material/Add";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import EditIcon from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../Data/AuthUser";

import {
  ticketApis,
  departmentHRApi,
  designationHRApi,
  DesignationApis,
  BusinessSettingsApi,
} from "../../Data/axios";

// New imports for updated table structure
import TicketsHeader from "./TicketsHeader";
import TicketsTableDiff from "./SubComponents/TicketsTableDiff";
import TicketStatsCards from "./TicketStatsCards";
import { useTicketsTableActions } from "./SubComponents/hooks/useTicketsTableActions";
import CreateTicketDrawer from "./CreateTicketDrawer";
import DeleteConfirmDialog from "./SubComponents/components/DeleteConfirmDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Tickets() {
  const [name, setName] = React.useState("");
  const [priorityTicket, setPriorityTicket] = React.useState("");
  const [selectedGroup, setSelectedGroup] = React.useState("");
  const [selectedType, setSelectedType] = React.useState("");
  const [selectedAgent, setSelectedAgent] = React.useState("");
  const [selectedChannel, setSelectedChannel] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [statusValue, setStatusValue] = React.useState("");
  const [requesterId, setRequesterId] = React.useState("");
  const [requester, setRequester] = useState("Client");

  const [uploadFile, setUploadFile] = useState(null);

  const [tagTicket, setTagTicket] = useState("");

  const [open, setOpen] = React.useState(false);
  const [createTicketDrawerOpen, setCreateTicketDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState("create");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [departments, setDepartments] = useState(["test1", "test2"]);
  const [designations, setDesignations] = useState([]);

  // New state for updated table structure
  const [ticketData, setTicketData] = useState([]);
  const [deleting, setDeleting] = useState(false);
  const [queries, setQueries] = useState({
    page: 1,
    per_page: 10,
    total: 0,
  });

  // Filter state for new header
  const [filters, setFilters] = useState({
    duration: "All Time",
    status: "All",
    title: "",
  });

  const showAlert = useCallback(
    (message, severity) => {
      setAlertMessage(message);
      setAlertSeverity(severity);
      setAlertOpen(true);
    },
    [setAlertMessage, setAlertSeverity, setAlertOpen]
  );

  // Handle filter changes for new header
  const handleFilterChange = (filterType, value) => {
    console.log(`Filter changed - ${filterType}: ${value}`);

    if (filterType === "clearAll") {
      setFilters({
        duration: "All Time",
        status: "All",
        title: "",
      });
      return;
    }

    if (filterType === "dateRange") {
      setFilters((prev) => {
        const { duration, ...restFilters } = prev;
        return {
          ...restFilters,
          from_date: value.from_date,
          to_date: value.to_date,
        };
      });
    } else {
      setFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    }
  };

  // Handle stats card click -> apply status filter
  const handleStatsCardClick = (statusFilter) => {
    setFilters((prev) => ({
      ...prev,
      status: statusFilter,
    }));
  };

  // Handle ticket row click -> navigate to view more tickets (same as view action)
  const handleRowClick = (row) => {
    navigate(`/tickets/${row.id}`, { state: row });
  };

  // Function to fetch ticket data for the new table
  const fetchTicketData = useCallback(
    async () => {
      try {
        const params = {};
        if (filters.status && filters.status !== "All") {
          const statusToId = { "Open": 1, "Assigned": 2, "Resolved": 3, "Closed": 4, "Pending": 2 };
          params.status = statusToId[filters.status] || filters.status;
        }
        if (filters.title) params.search = filters.title;
        if (filters.from_date) params.start_date = filters.from_date;
        if (filters.to_date) params.end_date = filters.to_date;

        const response = await ticketApis.getTicketonDashboard(params);
        console.log("Dashboard API Response:", response.data);

        if (response.success && response.data && Array.isArray(response.data.tickets)) {
          const idToStatus = { "1": "Open", "2": "Assigned", "3": "Resolved", "4": "Closed" };
          const mappedTickets = response.data.tickets.map(t => ({
            ...t,
            statusLabel: idToStatus[t.status] || t.status
          }));

          setEmployeeData(mappedTickets);
          setTicketData(mappedTickets);
          setQueries((prev) => ({ ...prev, total: mappedTickets.length }));
        } else {
          console.warn("API returned invalid data format:", response);
          setEmployeeData([]);
          setTicketData([]);
        }
      } catch (error) {
        console.error("Failed to fetch actual ticket dashboard data:", error);
        setEmployeeData([]);
        setTicketData([]);
        showAlert("Failed to load ticket data", "error");
      }
    },
    [showAlert, filters]
  );

  // Table actions for new table
  const tableActions = useTicketsTableActions(ticketApis, fetchTicketData, (ticketData) => {
    setSelectedTicket(ticketData);
    setDrawerMode("update");
    setCreateTicketDrawerOpen(true);
  });

  // Handle delete confirmation with loading state
  const handleDeleteConfirm = async () => {
    setDeleting(true);
    try {
      await tableActions.handleDeleteConfirm();
      showAlert("Ticket deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting ticket:", error);
      showAlert("Failed to delete ticket", "error");
    } finally {
      setDeleting(false);
    }
  };

  const handleChange = (event) => {
    setRequester(event.target.value);
  };

  const handleFileChange = (event) => {
    setUploadFile(event.target.files[0]);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState([]);

  const [selection, setSelection] = useState("open");
  const handleChangeSelected = (event, newValue) => {
    setSelection(newValue);
  };
  // Function Starts Here

  const [updateMember, setUpdateMember] = React.useState("");
  const [updateLeaveType, setUpdateLeaveType] = React.useState("");

  const [updateDuration, setUpdateDuration] = React.useState("");
  const [updateDate, setUpdateDate] = useState(null); // Initialize state for the date
  const [updateMemberError, setUpdateMemberError] = React.useState(false);
  const [updateReason, setUpdateReason] = useState("");
  const [updateFileName, setUpdateFileName] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };
  const statusType = ["Open", "Closed", "Assigned", "Resolved"];

  const item = {
    ticket_priority_id: priorityTicket,
    assing_group: selectedGroup,
    agent: selectedAgent,
    ticket_channel: selectedChannel,
    subject: subject,
    requester: requester,
    file: uploadFile,
    tags: tagTicket,
    requester_id: requesterId,
    status: "1",
  };

  async function SaveDate() {
    // Create a new FormData object
    const formData = new FormData();

    // Append each item to the FormData object
    for (const key in item) {
      if (item[key] !== undefined && item[key] !== null) {
        formData.append(key, item[key]);
      }
    }

    // let result = await fetch(
    //   "https://rptpl.roadpilot.co.in/public/api/createtickets",
    //   {
    //     method: "POST",
    //     body: formData,
    //   }
    // );

    await ticketApis.createTicket(formData);

    showAlert("Added successfully", "success");

    getData();
    setOpen(false);
  }

  useEffect(() => {
    fetchTicketData();
  }, [fetchTicketData]);

  // Update the getData function to handle potential issues
  async function getData() {
    try {
      // let results = await fetch(
      //   "https://rptpl.roadpilot.co.in/public/api/getTickets"
      // );

      const response = await ticketApis.getTickets();
      console.log("API Response:", response);

      // Ensure we're setting valid array data
      if (Array.isArray(response.data.data)) {
        // console.log("Setting employee data:", response.data.data);
        setEmployeeData(response.data.data);
      } else {
        console.error("API returned non-array data:", response);
        setEmployeeData([]); // Set to empty array as fallback
      }
    } catch (error) {
      console.error("Failed to fetch ticket data:", error);
      setEmployeeData([]); // Ensure it's always an array
      showAlert("Failed to load ticket data", "error");
    }
  }

  // Update Values Start

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDesig, setOpenDialogDesig] = useState(false);
  const [newDepartment, setNewDepartment] = useState("");
  const [newParentDepartment, setNewParentDepartment] = useState("");
  const [newParentDesignation, setNewParentDesignation] = useState("");

  const [newDesignation, setNewDesignation] = useState("");
  const fetchData = async () => {
    try {
      const data = await departmentHRApi.getAll();
      // console.log("Department Data:", data.data);

      // Ensure departments is always an array
      if (Array.isArray(data.data)) {
        setDepartments(data.data);
      } else if (data && Array.isArray(data.data)) {
        setDepartments(data.data);
      } else {
        console.error("API returned non-array data for departments:", data);
        setDepartments([]); // Set to empty array as fallback
      }
    } catch (err) {
      console.error("Error fetching departments:", err);
      setDepartments([]); // Ensure it's an array even on error
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const fetchDataDesignation = async () => {
    try {
      // const response = await fetch(
      //   "https://rptpl.roadpilot.co.in/public/api/getDesignation"
      // );
      // const data = await response.json();

      const data = designationHRApi.getAll();

      // Ensure designations is always an array
      if (Array.isArray(data)) {
        setDesignations(data);
      } else {
        console.error("API returned non-array data for designations:", data);
        setDesignations([]); // Set to empty array as fallback
      }
    } catch (err) {
      console.error("Error fetching designations:", err);
      setDesignations([]); // Ensure it's an array even on error
    }
  };
  useEffect(() => {
    fetchDataDesignation();
  }, []);

  const handleAddClick = () => {
    setOpenDialog(true); // Open dialog when Add button is clicked
  };
  const handleAddClickDesig = () => {
    setOpenDialogDesig(true); // Open dialog when Add button is clicked
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
    setNewDepartment("");
    setNewParentDepartment(""); // Reset input field
  };
  const handleDialogCloseDesig = () => {
    setOpenDialogDesig(false);
    setNewDesignation("");
    setNewParentDesignation("");
  };
  async function AddDepartment() {
    const creator_name = localStorage.getItem("empid");
    // let result = await fetch(
    //   `https://rptpl.roadpilot.co.in/public/api/addDepartment?department=${newDepartment}&parent=${newParentDesignation}&creator_id=${creator_name}`,
    //   {
    //     method: "POST",
    //   }
    // );

    // result = await result.json();

    const formData = new FormData();
    formData.add("department", newDepartment);
    formData.add("parent", newParentDepartment);
    formData.add("creator_id", creator_name);

    departmentHRApi.add(formData);

    showAlert(" Added successfully", "success");

    fetchData();
    handleDialogClose();
  }
  async function AddDesignation() {
    const creator_name = localStorage.getItem("empid");
    // let result = await fetch(
    //   `https://rptpl.roadpilot.co.in/public/api/addDesignation?designation=${newDesignation}&parent=${newParentDesignation}&creator=${creator_name}`,
    //   {
    //     method: "POST",
    //   }
    // );

    const formData = new FormData();
    formData.append("designation", newDesignation);
    formData.append("parent", newParentDesignation);
    formData.append("creator", creator_name);

    await DesignationApis.add(formData);

    showAlert(" Added successfully", "success");

    fetchDataDesignation();
    handleDialogCloseDesig();
  }

  // Delete functionality removed as requested
  // async function handleDelete(id) {
  //   const response = await ticketApis.deleteTicketById(id);
  //   getData();
  //   showAlert(" Deleted successfully", "warning");
  // }

  const handleCancel = () => {};

  // Table settings for new table
  const headers = [
    { key: "id", label: "TICKET #", sortable: true },
    { key: "subject", label: "TICKET SUBJECT", sortable: true },
    { key: "requester_name", label: "REQUESTER NAME", sortable: true },
    { key: "created_at", label: "REQUESTED ON", sortable: true },
    { key: "others", label: "OTHERS", sortable: false },
    { key: "statusLabel", label: "STATUS", sortable: true },
    { key: "action", label: "ACTION", sortable: false },
  ];

  const handlePageChange = (newPage) => {
    setQueries({ ...queries, page: newPage });
  };

  const handlePerPageChange = (newPerPage) => {
    setQueries({ ...queries, per_page: newPerPage, page: 1 });
  };

  // Table Ends Here
  const priorityType = ["Low", "Medium", "High", "Urgent"];
  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      {/* New Header */}
      <TicketsHeader onFilterChange={handleFilterChange} filters={filters} />

      {/* Ticket Statistics Cards */}
      <TicketStatsCards ticketData={ticketData} onCardClick={handleStatsCardClick} />

      {/* Add Ticket Button */}
      <Box
        display="flex"
        justifyContent="flex-start"
        sx={{ marginBottom: "16px" }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            setDrawerMode("create");
            setSelectedTicket(null);
            setCreateTicketDrawerOpen(true);
          }}
          sx={{
            bgcolor: "#4285F4",
            color: "white",
            "&:hover": {
              bgcolor: "#3367D6",
            },
            marginTop: "10px",
            marginLeft: "16px",
            paddingY: "8px",
            borderRadius: "4px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          Create Ticket
        </Button>
      </Box>

      {/* New Table */}
      <TicketsTableDiff
        headers={headers}
        data={ticketData}
        rowKey="id"
        defaultSortKey=""
        tableActions={tableActions}
        onRowClick={handleRowClick}
        onPageChange={handlePageChange}
        onPerPageChange={handlePerPageChange}
        queries={queries}
        tableClassName="tickets-table"
        tableStyle={{ fontSize: "16px", fontFamily: "Ubuntu" }}
      />

      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Ticket Details
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ background: "#fff" }}>
          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px" }}
          >
            <Grid item xs={8} sm={3.5} md={3.5}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{
                    color: "black",
                    padding: "4px",
                    borderRadius: "4px",
                  }}
                >
                  Requester
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={requester}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Client"
                    control={
                      <Radio
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "gray" },
                        }}
                      />
                    }
                    label="Client"
                  />
                  <FormControlLabel
                    value="Employee"
                    control={
                      <Radio
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "gray" },
                        }}
                      />
                    }
                    label="Employee"
                  />
                  <FormControlLabel
                    value="App User"
                    control={
                      <Radio
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "gray" },
                        }}
                      />
                    }
                    label="App User"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={8} sm={3.5} md={3.5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Requester Name
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="department-select-label"
                      id="department-select"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      {Array.isArray(departments) ? (
                        departments.map((department) => (
                          <MenuItem
                            key={department.id}
                            value={department.department}
                          >
                            {department.department}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No options available</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px" }}
          >
            <Grid item xs={8} sm={5} md={5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Assign Group
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="designation-select-label"
                      id="designation-select"
                      value={selectedGroup}
                      onChange={(e) => setSelectedGroup(e.target.value)}
                      displayEmpty
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleAddClickDesig}
                            edge="end"
                            sx={{
                              color: "#000",
                              backgroundColor: "#fff",
                              "&:hover": {
                                backgroundColor: "#fff",
                                color: "#000",
                              },
                            }}
                          >
                            Add
                          </IconButton>
                        </InputAdornment>
                      }
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      {Array.isArray(designations) ? (
                        designations.map((item) => (
                          <MenuItem key={item.id} value={item.designation}>
                            {item.designation}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No options available</MenuItem>
                      )}
                    </Select>

                    {/* Dialog for adding new department */}
                    <Dialog
                      fullWidth
                      maxWidth="md"
                      open={openDialogDesig}
                      onClose={handleDialogCloseDesig}
                      TransitionComponent={Transition}
                      PaperProps={{
                        style: {
                          position: "absolute",
                          background: "#141b2d",
                          top: "0",
                          backgroundColor: "white",
                          maxHeight: "95%",
                          margin: "auto",
                          overflowX: "hidden",
                          zIndex: 1200,
                        },
                      }}
                    >
                      <Box sx={{ background: "#fff", color: "#000" }}>
                        <DialogTitle>
                          <span
                            style={{
                              background: "blue",
                              color: "#fff",
                              padding: "15px",
                              borderRadius: "5px",
                            }}
                          >
                            Add New Designation
                          </span>
                        </DialogTitle>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            marginTop: "10px",
                            padding: { xs: "10px", sm: "20px" },
                          }}
                        >
                          <Grid item xs={12} sm={6} md={5.5}>
                            <Stack direction="column" spacing={2}>
                              <Typography>Group Name </Typography>
                              <TextField
                                autoFocus
                                margin="dense"
                                placeholder="Designation Name"
                                type="text"
                                fullWidth
                                value={newDesignation}
                                onChange={(e) =>
                                  setNewDesignation(e.target.value)
                                }
                                inputProps={{ style: { color: "black" } }}
                                InputLabelProps={{
                                  style: { color: "black" },
                                }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black",
                                    "&:hover fieldset": {
                                      borderColor: "black",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black",
                                    },
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    "&::placeholder": { color: "gray" },
                                  },
                                }}
                              />
                            </Stack>
                          </Grid>

                          <Grid item xs={11.5} sx={{ textAlign: "start" }}>
                            <DialogActions>
                              <Button
                                onClick={handleDialogCloseDesig}
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={AddDesignation}
                                color="primary"
                                sx={{
                                  background: "blue",
                                  color: "#fff",
                                  "&:hover": {
                                    background: "#000",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </DialogActions>
                          </Grid>
                        </Grid>
                      </Box>
                    </Dialog>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={5} md={5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Agent
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="department-select-label"
                      id="department-select"
                      value={selectedAgent}
                      onChange={(e) => setSelectedAgent(e.target.value)}
                      displayEmpty
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleAddClick}
                            edge="end"
                            sx={{
                              color: "#000",
                              backgroundColor: "#fff",
                              "&:hover": {
                                backgroundColor: "#fff",
                                color: "#000",
                              },
                            }}
                          >
                            Add
                          </IconButton>
                        </InputAdornment>
                      }
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      {Array.isArray(departments) ? (
                        departments.map((department) => (
                          <MenuItem
                            key={department.id}
                            value={department.department}
                          >
                            {department.department}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No options available</MenuItem>
                      )}
                    </Select>

                    {/* Dialog for adding new department */}
                    <Dialog
                      fullWidth
                      maxWidth="md"
                      open={openDialog}
                      onClose={handleDialogClose}
                      TransitionComponent={Transition}
                      PaperProps={{
                        style: {
                          position: "absolute",
                          background: "#141b2d",
                          top: "0",
                          backgroundColor: "white",
                          maxHeight: "95%",
                          margin: "auto",
                          overflowX: "hidden",
                          zIndex: 1200,
                        },
                      }}
                    >
                      <Box sx={{ background: "#fff", color: "#000" }}>
                        <DialogTitle>
                          <span
                            style={{
                              background: "blue",
                              color: "#fff",
                              padding: "15px",
                              borderRadius: "5px",
                            }}
                          >
                            Add New Ticket Agent
                          </span>
                        </DialogTitle>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            padding: { xs: "10px", sm: "20px" },
                          }}
                        >
                          <Grid item xs={12} sm={6} md={6}>
                            <Stack direction="column" spacing={2}>
                              <Typography>Assign Group </Typography>
                              <Select
                                value={newParentDepartment}
                                autoFocus
                                fullWidth
                                onChange={(e) =>
                                  setNewParentDepartment(e.target.value)
                                }
                                displayEmpty
                                inputProps={{
                                  "aria-label": "Without label",
                                }}
                                sx={{
                                  border: "1px solid black",
                                  boxSizing: "border-box",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              >
                                <MenuItem disabled value="">
                                  <em>---</em>
                                </MenuItem>
                                {departments.map((department) => (
                                  <MenuItem
                                    key={department.id}
                                    value={department.department}
                                  >
                                    {department.department}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Stack>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Stack direction="column" spacing={2}>
                              <Typography>Agent </Typography>
                              <Select
                                value={newParentDepartment}
                                autoFocus
                                fullWidth
                                onChange={(e) =>
                                  setNewParentDepartment(e.target.value)
                                }
                                displayEmpty
                                inputProps={{
                                  "aria-label": "Without label",
                                }}
                                sx={{
                                  border: "1px solid black",
                                  boxSizing: "border-box",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              >
                                <MenuItem disabled value="">
                                  <em>---</em>
                                </MenuItem>
                                {departments.map((department) => (
                                  <MenuItem
                                    key={department.id}
                                    value={department.department}
                                  >
                                    {department.department}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Stack>
                          </Grid>

                          <Grid item xs={11.5} sx={{ textAlign: "start" }}>
                            <DialogActions>
                              <Button
                                onClick={handleDialogClose}
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={AddDepartment}
                                color="primary"
                                sx={{
                                  background: "blue",
                                  color: "#fff",
                                  "&:hover": {
                                    background: "#000",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </DialogActions>
                          </Grid>
                        </Grid>
                      </Box>
                    </Dialog>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px" }}
          >
            <Grid item xs={11} sm={11} md={11}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Ticket Subject
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <br></br>
                  <TextField
                    fullWidth
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="e.g.hindi, english"
                    inputProps={{ style: { color: "black" } }}
                    InputLabelProps={{ style: { color: "black" } }}
                    sx={{
                      border: "1px solid black",
                      borderRadius: "5px",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black",
                        "&:hover fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        "&::placeholder": { color: "gray" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container sx={{ padding: "20px" }}>
            <Stack direction="column" sx={{ width: "100%" }}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Description<span style={{ color: "red" }}>*</span>
              </Typography>

              <ReactQuill
                value={description}
                onChange={setDescription}
                modules={modules}
                theme="snow"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  color: "black",
                  borderBlockColor: "black",
                }}
              />
            </Stack>
          </Grid>
          <Grid container sx={{ padding: "20px" }}>
            <Stack direction="column" sx={{ width: "100%" }}>
              <br></br>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Add File
              </Typography>
              <label
                htmlFor="file-upload"
                style={{
                  cursor: "pointer",
                  color: "black",
                  border: "1px solid black",
                  borderRadius: "4px",
                  padding: "10px",
                  width: "100%",
                  boxSizing: "border-box",
                  minHeight: "100px", // Set your desired minimum height
                  backgroundColor: "lightgray", // Change background color to light gray
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Choose a File
              </label>
              <input
                onChange={handleFileChange}
                type="file"
                id="file-upload"
                style={{ display: "none" }}
              />
              {uploadFile && (
                <div style={{ color: "black" }}>{uploadFile.name}</div>
              )}
            </Stack>
          </Grid>
          <Grid container spacing={2} sx={{ color: "black", padding: "20px" }}>
            <Grid item xs={8} sm={3.5} md={3.5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Priority
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="department-select-label"
                      id="department-select"
                      value={priorityTicket}
                      onChange={(e) => setPriorityTicket(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      {priorityType.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={3.5} md={3.5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Type
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="designation-select-label"
                      id="designation-select"
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.target.value)}
                      displayEmpty
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleAddClickDesig}
                            edge="end"
                            sx={{
                              color: "#000",
                              backgroundColor: "#fff",
                              "&:hover": {
                                backgroundColor: "#fff",
                                color: "#000",
                              },
                            }}
                          >
                            Add
                          </IconButton>
                        </InputAdornment>
                      }
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      {Array.isArray(designations) ? (
                        designations.map((item) => (
                          <MenuItem key={item.id} value={item.designation}>
                            {item.designation}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No options available</MenuItem>
                      )}
                    </Select>

                    {/* Dialog for adding new department */}
                    <Dialog
                      fullWidth
                      maxWidth="md"
                      open={openDialogDesig}
                      onClose={handleDialogCloseDesig}
                      TransitionComponent={Transition}
                      PaperProps={{
                        style: {
                          position: "absolute",
                          background: "#141b2d",
                          top: "0",
                          backgroundColor: "white",
                          maxHeight: "95%",
                          margin: "auto",
                          overflowX: "hidden",
                          zIndex: 1200,
                        },
                      }}
                    >
                      <Box sx={{ background: "#fff", color: "#000" }}>
                        <DialogTitle>
                          <span
                            style={{
                              background: "blue",
                              color: "#fff",
                              padding: "15px",
                              borderRadius: "5px",
                            }}
                          >
                            Add New Ticket Type
                          </span>
                        </DialogTitle>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            marginTop: "10px",
                            padding: { xs: "10px", sm: "20px" },
                          }}
                        >
                          <Grid item xs={11} sm={11} md={11}>
                            <Stack direction="column" spacing={2}>
                              <Typography>Ticket Type </Typography>
                              <TextField
                                autoFocus
                                margin="dense"
                                placeholder="Designation Name"
                                type="text"
                                fullWidth
                                value={newDesignation}
                                onChange={(e) =>
                                  setNewDesignation(e.target.value)
                                }
                                inputProps={{ style: { color: "black" } }}
                                InputLabelProps={{
                                  style: { color: "black" },
                                }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black",
                                    "&:hover fieldset": {
                                      borderColor: "black",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black",
                                    },
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    "&::placeholder": { color: "gray" },
                                  },
                                }}
                              />
                            </Stack>
                          </Grid>

                          <Grid item xs={11.5} sx={{ textAlign: "start" }}>
                            <DialogActions>
                              <Button
                                onClick={handleDialogCloseDesig}
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={AddDesignation}
                                color="primary"
                                sx={{
                                  background: "blue",
                                  color: "#fff",
                                  "&:hover": {
                                    background: "#000",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </DialogActions>
                          </Grid>
                        </Grid>
                      </Box>
                    </Dialog>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={3.5} md={3.5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Channel Name
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="department-select-label"
                      id="department-select"
                      value={selectedChannel}
                      onChange={(e) => setSelectedChannel(e.target.value)}
                      displayEmpty
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleAddClick}
                            edge="end"
                            sx={{
                              color: "#000",
                              backgroundColor: "#fff",
                              "&:hover": {
                                backgroundColor: "#fff",
                                color: "#000",
                              },
                            }}
                          >
                            Add
                          </IconButton>
                        </InputAdornment>
                      }
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>

                      {departments.map((department) => (
                        <MenuItem
                          key={department.id}
                          value={department.department}
                        >
                          {department.department}
                        </MenuItem>
                      ))}
                    </Select>

                    {/* Dialog for adding new department */}
                    <Dialog
                      fullWidth
                      maxWidth="md"
                      open={openDialog}
                      onClose={handleDialogClose}
                      TransitionComponent={Transition}
                      PaperProps={{
                        style: {
                          position: "absolute",
                          background: "#141b2d",
                          top: "0",
                          backgroundColor: "white",
                          maxHeight: "95%",
                          margin: "auto",
                          overflowX: "hidden",
                          zIndex: 1200,
                        },
                      }}
                    >
                      <Box sx={{ background: "#fff", color: "#000" }}>
                        <DialogTitle>
                          <span
                            style={{
                              background: "blue",
                              color: "#fff",
                              padding: "15px",
                              borderRadius: "5px",
                            }}
                          >
                            Add Ticket Channel
                          </span>
                        </DialogTitle>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            padding: { xs: "10px", sm: "20px" },
                          }}
                        >
                          <Grid item xs={11} sm={11} md={11}>
                            <Stack direction="column" spacing={2}>
                              <Typography>Ticket Channel </Typography>
                              <Select
                                value={newParentDepartment}
                                autoFocus
                                fullWidth
                                onChange={(e) =>
                                  setNewParentDepartment(e.target.value)
                                }
                                displayEmpty
                                inputProps={{
                                  "aria-label": "Without label",
                                }}
                                sx={{
                                  border: "1px solid black",
                                  boxSizing: "border-box",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              >
                                <MenuItem disabled value="">
                                  <em>---</em>
                                </MenuItem>
                                {/* {departments.map((department) => (
                                      <MenuItem
                                        key={department.id}
                                        value={department.department}
                                      >
                                        {department.department}
                                      </MenuItem>
                                    ))} */}
                              </Select>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Box>
                    </Dialog>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px" }}
          >
            <Grid item xs={11} sm={11} md={11}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Tags
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <br></br>
                  <TextField
                    fullWidth
                    value={tagTicket}
                    onChange={(e) => setTagTicket(e.target.value)}
                    placeholder="e.g.hindi, english"
                    inputProps={{ style: { color: "black" } }}
                    InputLabelProps={{ style: { color: "black" } }}
                    sx={{
                      border: "1px solid black",
                      borderRadius: "5px",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black",
                        "&:hover fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        "&::placeholder": { color: "gray" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px" }}
          >
            <Grid item xs={11} sm={11} md={11}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Requester Id
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <br></br>
                  <TextField
                    fullWidth
                    value={requesterId}
                    onChange={(e) => setRequesterId(e.target.value)}
                    placeholder="e.g. 123, 234..."
                    inputProps={{ style: { color: "black" } }}
                    InputLabelProps={{ style: { color: "black" } }}
                    sx={{
                      border: "1px solid black",
                      borderRadius: "5px",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black",
                        "&:hover fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        "&::placeholder": { color: "gray" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={3.5} md={3.5}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Status
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <Select
                      labelId="department-select-label"
                      id="department-select"
                      value={statusValue}
                      onChange={(e) => setStatusValue(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>

                      {statusType.map((department) => (
                        <MenuItem key={department} value={department}>
                          {department}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              padding: {
                xs: "50px 10px 20px 10px",
                sm: "30px 10px 20px 10px",
                md: "20px 10px 20px 10px",
              },
            }}
          >
            <Grid item xs={11} className="messageFooter">
              <Box className="response" onClick={SaveDate}>
                Save
              </Box>
              <Box className="cancel" onClick={handleCancel}>
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      {/* Create Ticket Drawer */}
      <CreateTicketDrawer
        open={createTicketDrawerOpen}
        onClose={() => setCreateTicketDrawerOpen(false)}
        onTicketCreated={fetchTicketData}
        onTicketUpdated={fetchTicketData}
        showAlert={showAlert}
        mode={drawerMode}
        ticketData={selectedTicket}
      />

      {/* Delete Confirmation Dialog */}
      <DeleteConfirmDialog
        open={tableActions.showDeleteDialog}
        onClose={tableActions.handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        deleting={deleting}
        ticketData={tableActions.deleteData}
      />
    </>
  );
}

export default Tickets;
